import { ConnectButton } from "@rainbow-me/rainbowkit";
import SWAP_ABI from "abi/SWAP.json";
import Button from "components/Button";
import useWindowSize from "hooks/useWindowResize";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoWallet } from "react-icons/io5";
import { sliceString } from "utils/hepler";
import { useAccount, useContractReads, useContractWrite } from "wagmi";
import { StyledStaking, Styles } from "./styles";

// const swapAddress = "0xB68017D549EB5D12281e105C2c871fdF71AcCC0c";
const swapAddress = "0xDDBbFBF13101c965c4b5C974F94834cda4aa1d67";

const Swap = () => {
  const [price, setPrice] = useState("");
  const [feeI, setFee] = useState("");
  const { data: dataConfig, refetch } = useContractReads({
    contracts: [
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "swapFee",
      },
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "tokenInRate",
      },
    ],
  });
  useEffect(() => {
    let timer = setInterval(() => {
      refetch();
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  });
  const [fee, rate] = dataConfig ? dataConfig : [];

  const { writeAsync: setFeeAir } = useContractWrite({
    address: swapAddress,
    abi: SWAP_ABI as any,
    functionName: "setFee",
    onError: (err) => {
      toast.error(err.message);
    },
    onSuccess: () => {
      toast.success("Successfully!");
    },
  });

  const { writeAsync: setRate } = useContractWrite({
    address: swapAddress,
    abi: SWAP_ABI as any,
    functionName: "setRate",
    onError: (err) => {
      toast.error(err.message);
    },
    onSuccess: () => {
      toast.success("Successfully!");
    },
  });

  return (
    <Styles>
      <div className="container">
        <div className="module">
          <div className="header">
            <p className="title">Config CATAI</p>
            <ButtonConnect />
          </div>
          <div className="content-module">
            <div className="item-group">
              <StyledStaking>
                <div className="staking-top">
                  <div className="head">
                    <div className="text text-left">Set Price</div>
                    <div className="text text-right">
                      {rate?.status
                        ? +(rate?.result?.toString() || 0) / 1000
                        : 0}{" "}
                      USDT{" "}
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      value={price}
                      type="number"
                      onChange={(e) => {
                        setPrice(
                          e.target.value
                            ? (+e.target.value.toString() as any)
                            : ""
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="bt">
                  <Button
                    onClick={() => {
                      if (!price) return toast.error("Price invalid");
                      setRate({
                        args: [+price * 1000],
                      });
                    }}
                    disabled={!price}
                  >
                    Submit
                  </Button>
                </div>
              </StyledStaking>
            </div>
          </div>
          <div className="content-module">
            <div className="item-group">
              <StyledStaking>
                <div className="staking-top">
                  <div className="head">
                    <div className="text text-left">Set Fee</div>
                    <div className="text text-right">
                      {fee?.status ? +(fee?.result?.toString() || 0) / 1000 : 0}
                      %
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      value={feeI}
                      type="number"
                      onChange={(e) => {
                        setFee(
                          e.target.value
                            ? (+e.target.value.toString() as any)
                            : ""
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="bt">
                  <Button
                    onClick={() => {
                      if (!feeI) return toast.error("Fee invalid");
                      setFeeAir({
                        args: [+feeI * 1000],
                      });
                    }}
                    disabled={!feeI}
                  >
                    Submit
                  </Button>
                </div>
              </StyledStaking>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Swap;

export const ButtonConnect = () => {
  const { width } = useWindowSize();
  const { address } = useAccount();
  return (
    <ConnectButton.Custom>
      {({ openAccountModal, openConnectModal }) => {
        if (!address) {
          return (
            <button
              className="btn_connect btn connect"
              onClick={openConnectModal}
            >
              <IoWallet /> Connect {width > 1300 && "Wallet"}
            </button>
          );
        }
        return (
          <button
            className="button btn_connect"
            onClick={openAccountModal}
            type="button"
          >
            {sliceString(address, 5)}
          </button>
        );
      }}
    </ConnectButton.Custom>
  );
};
